// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__BdaUe","img":"recipe_img__36hzO","title":"recipe_title__1jR5P","ingr":"recipe_ingr__TCqIE"};